<template>
  <div class="menu-wrapper">
    <pinch-zoom
      :autoHeight="true"
      :doubleTap="true"
      :wheel="false"
      :draggableImage="false"
      disableZoomControl="never"
    >
      <b-row>
        <b-col v-for="(item, i) in posts" :key="i" cols="12">
          <div class="d-flex justify-content-center w-100">
            <b-img
              class="w-100"
              style="object-fit: contain"
              :src=" item.url"
            ></b-img>
          </div>
        </b-col>
      </b-row>
    </pinch-zoom>
    <!-- <flipbook class="flipbook" ref="book" :flipDuration="3000" :zooms='[1, 2]' :ambient=1 :singlePage=false
                :pages="activeImages" v-slot="flipbook">
                <div class="action-bar d-flex justify-content-center ">
                    <b-button class="p-0" variant="transparent">
                        <unicon fill="#fff" name='angle-left' class="btn left"
                            :class="{ disabled: !flipbook.canFlipLeft }" @click="flipbook.flipLeft" />
                    </b-button>
                    <span class="page-num text-center text-light">
                        Page {{ flipbook.page }} of {{ flipbook.numPages }}
                    </span>
                    <b-button class="p-0" variant="transparent">
                        <unicon fill="#fff" name="angle-right" class="btn right"
                            :class="{ disabled: !flipbook.canFlipRight }" @click="flipbook.flipRight" />
                    </b-button>
                </div>

            </flipbook> -->
  </div>
</template>

<script>
// import Flipbook from 'flipbook-vue'
import PinchZoom from "vue-pinch-zoom";
    import axios from 'axios';
    import { $themeConfig } from '@themeConfig'
export default {
  components: {
    // Flipbook,
    PinchZoom,
  },
  data() {
    return {
      ar: [
        "/ar_menu/01.jpg",
        "/ar_menu/02.jpg",
        "/ar_menu/03.jpg",
        "/ar_menu/04.jpg",
        "/ar_menu/05.jpg",
        "/ar_menu/06.jpg",
        "/ar_menu/07.jpg",
        "/ar_menu/08.jpg",
        "/ar_menu/09.jpg",
        "/ar_menu/10.jpg",
        "/ar_menu/11.jpg",
        "/ar_menu/12.jpg",
        "/ar_menu/13.jpg",
        "/ar_menu/14.jpg",
        "/ar_menu/15.jpg",
        "/ar_menu/16.jpg",
        "/ar_menu/17.jpg",
        "/ar_menu/18.jpg",
        "/ar_menu/19.jpg",
        "/ar_menu/20.jpg",
      ],
      kur: [
        "/kur_meun/01.jpg",
        "/kur_meun/02.jpg",
        "/kur_meun/03.jpg",
        "/kur_meun/04.jpg",
        "/kur_meun/05.jpg",
        "/kur_meun/06.jpg",
        "/kur_meun/07.jpg",
        "/kur_meun/08.jpg",
        "/kur_meun/09.jpg",
        "/kur_meun/10.jpg",
        "/kur_meun/11.jpg",
        "/kur_meun/12.jpg",
        "/kur_meun/13.jpg",
        "/kur_meun/14.jpg",
        "/kur_meun/15.jpg",
        "/kur_meun/16.jpg",
        "/kur_meun/17.jpg",
        "/kur_meun/18.jpg",
        "/kur_meun/19.jpg",
        "/kur_meun/20.jpg",
        ],
        posts: [ 
        ],

    };
  },
  computed: {
    activeImages() {
      return this[this.$route.query.lang];
    },
  },
  methods: {
    zoom(scale) {
      document.body.style.transform = "scale(" + scale + ")";
      document.body.style.transformOrigin = "top left";
      document.body.style.width = 100 / scale + "%";
      document.body.style.height = 100 / scale + "%";
    },
        },
        created() {
            var test = this.$route.query.lang == 'ar' ? 1 : this.$route.query.lang == 'kur' ? 3 : 2;
            axios.get($themeConfig.app.domainPath + "/api/Image/GetAll?language=" + test)
                .then(response => {
                    // JSON responses are automatically parsed.
                    response.data.forEach(element =>
                        element.url = $themeConfig.app.domainPath +  "/" + element.url
                    );

               
                    this.posts = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
        },

  mounted() {
    // const vm = this
    // window.addEventListener('dblclick', () => {
    //     if (vm.$refs['book'].canZoomIn)
    //         vm.$refs['book'].zoomIn()
    //     else if (vm.$refs['book'].canZoomOut)
    //         vm.$refs['book'].zoomOut()
    // }
    // )
  },
};
</script>


<style>
.menu-wrapper {
  min-height: 100vh;

  background-color: #2b2b2b;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.flipbook {
  width: 100vw;
  height: 100vh;
}

img {
  top: 0;
}

.action-bar {
  display: flex;
  justify-content: space-between !important;
}

.page-num {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}
@media only screen and (orientation: landscape) {
  img {
    height: 100vh;
  }
}
</style>